exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer-top[data-v-5b5a2952]{color:#89cbdd!important;background:#f1f1f1!important}.footer-container[data-v-5b5a2952]{overflow:hidden}", ""]);
